<template>
  <div class="layout">
    <div v-if="left && right" class="book-view">
      <div v-if="left" class="left">
        <slot name="left" />
      </div>
      <div v-if="right" class="right">
        <h3 v-if="header">{{ header }}</h3>
        <div v-if="hook" class="hook">{{ hook }}</div>
        <slot name="right" />
      </div>
    </div>

    <div v-else class="column">
      <h3 v-if="header" class="header">{{ header }}</h3>
      <slot name="default" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PageLayout",
  props: {
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: "",
    },
    hook: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.layout {
  background: linear-gradient(
    to bottom,
    var(--main-background),
    var(--secondary-background)
  );
  min-height: 12.5rem;
  padding: 3.125rem 13.33%;
  display: flex;
}
.column {
  flex-direction: column;
  margin: auto;
  width: 100%;
}
.book-view {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.hook {
  font-size: 1.25em;
  padding: 1em 0;
  font-style: italic;
  font-family: PT Serif, serif;
}
.header {
  font-size: 1.95em;
  padding-bottom: 18px;
  font-family: "Frank Ruhl Libre", serif;
  text-align: center;
  margin: 0;
}
.left {
  width: 25%;
  padding: 0 1em;
  text-align: right;
}
.right {
  width: 75%;
  padding: 0 1em;
  align-content: center;
}
@media (max-width: 1024px) {
  .layout {
    padding: 2rem 10%;
    max-width: 100%;
  }
}
@media (max-width: 768px) {
  .layout {
    padding: 2rem 10%;
    max-width: 100%;
  }
  .book-view {
    flex-direction: column;
    align-items: center;
  }
  .left {
    padding: 0;
    width: 100%;
  }
  .right {
    width: 100%;
    padding: 0;
  }
  .hook {
    text-align: center;
    font-size: 1.15em;
  }

  h3 {
    text-align: center;
  }

  .header {
    padding: 0;
  }
}
@media (max-width: 480px) {
  .layout {
    padding: 2rem 5%;
    max-width: 100%;
  }
  .book-view {
    flex-direction: column;
    align-items: center;
  }
  .left {
    display: none;
  }
  .right {
    width: 100%;
    padding: 0;
  }
  .header {
    padding: 0;
  }
}
</style>
